import { Tab } from '@mui/material';
import * as React from 'react';
import Path from '../libs/path/Path';

export default function LinkTab(props:any) {
    const onNav = (e:MouseEvent) => {
        e.preventDefault();
        Path.i.set(props.href)
    }
    return (
        <Tab component="a" onClick={onNav} {...props}/>
    );
}
